module.exports = __webpack_public_path__ + "img/operator_status_icon.6afa25c7.svg";